module.exports = __webpack_public_path__ + "img/ar2.735af151.jpg";